module.exports = __webpack_public_path__ + "img/success-summary.74694607.svg";